<div class="container-scroller">
  <div class="auth-form-light text-center py-5 px-10 px-sm-5 position-relative">
    <img src="../../assets/svg/emailVerifiedIcon.svg" alt="Success Icon" class="me-2">
    <h5 class="mt-3"> Password Reset! </h5>
    <p class="message">You successfully reset your password.</p>
    <div class="mt-3">
      <button type="submit" class="btn btn-block btn-primary btn-sm font-weight-medium auth-form-btn reset-button">
        <a routerLink="/login" class="reset-link">Log in</a>
      </button>
    </div>
  </div>
</div>
